import { User } from "../../../main/context/MainContextProvider";
import { TOKEN_KEY, api } from "../api-instance";
const ROUTE = "/login";
const ROUTE_LOGOUT = "/logout";

export type PostLogin = {
  userName: string;
  password: string;
  pushDeviceId: string | undefined;
};

export type PostLogout = {
  pushDeviceId: string | undefined;
};

export async function login(user: PostLogin): Promise<User> {
  const result = await api.post(ROUTE, user);
  const token = result.data.userAccessToken;
  const userData = decodeJwtToUser(token);
  localStorage.setItem(TOKEN_KEY, token);
  return userData;
}

export async function logout(logoutData: PostLogout): Promise<void> {
  try {
    await api.post(ROUTE_LOGOUT, logoutData);
  } catch (error) {
    console.warn("Erro no logout", error);
    // Em caso de erro, não faz nada
  }

  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem("user");
}

import jwtDecode from "jwt-decode";

function decodeLoginJwt(token: string): DecodedLoginToken | null {
  try {
    const decoded = jwtDecode(token) as DecodedLoginToken;

    return decoded;
  } catch (error) {
    return null;
  }
}
type DecodedLoginToken = {
  sub: string;
  name: string;
  email: string;
  phone: string;
  jti: string;
  client_id_and_name: { Item1: string; Item2: string }[];
  password_reseted: boolean;
  accepted_terms: boolean;
  usinas_codes: string[];
  roles: string[];
  nbf: number;
  exp: number;
  iat: number;
  iss: string;
  has_all_access: boolean;
};

function decodeJwtToUser(token: string): User {
  const decoded = decodeLoginJwt(token);
  if (!decoded) {
    throw new Error("Token inválido");
  }
  const clientIdAndName = decoded.client_id_and_name.map((client) => {
    return {
      id: client.Item1,
      name: client.Item2,
    };
  });
  return {
    userId: decoded.sub,
    name: decoded.name,
    email: decoded.email,
    phone: decoded.phone,
    roles: decoded.roles,
    clientIdAndName: clientIdAndName,
    passwordReseted: decoded.password_reseted,
    acceptedTerms: decoded.accepted_terms,
    userAccessToken: token,
    usinasIds: decoded.usinas_codes,
    expiration: new Date(decoded.exp * 1000),
    created: new Date(decoded.iat * 1000),
    hasAllAccess: decoded.has_all_access,
  };
}
